var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"sgz-wrapper"}},[_c('navigation'),_c('sgz-header'),_c('div',{attrs:{"id":"sgz-top-gradient"}}),_c('main-footer',{staticClass:"sgz-footer",attrs:{"siteName":"Survivor GameZ","socialLinks":false,"copyrightLinks":[]}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }